import { IYoutubeScrapeResponseItem } from "@shared/lib/types/influencer";

export type YoutubeCsvColumnKey = keyof IYoutubeScrapeResponseItem;

type YoutubeCsvColumn = {
  key: YoutubeCsvColumnKey;
  label: string;
  getValue: (item: IYoutubeScrapeResponseItem) => string | number | undefined;
};

export const YOUTUBE_CSV_COLUMNS: YoutubeCsvColumn[] = [
  {
    key: "trackedQuery",
    label: "Tracked Query",
    getValue: (item) => item.trackedQuery,
  },
  {
    key: "channelProfilePicUrl",
    label: "Channel Photo URL",
    getValue: (item) => item.channelProfilePicUrl,
  },
  {
    key: "channelName",
    label: "Channel Name",
    getValue: (item) => item.channelName,
  },
  {
    key: "channelId",
    label: "Channel ID",
    getValue: (item) => item.channelId,
  },
  {
    key: "channelUrl",
    label: "Channel URL",
    getValue: (item) => item.channelUrl,
  },
  {
    key: "channelSubscribers",
    label: "Subscribers",
    getValue: (item) => item.channelSubscribers,
  },
  {
    key: "videoUrl",
    label: "Video URL",
    getValue: (item) => item.videoUrl,
  },
  {
    key: "videoTitle",
    label: "Video Title",
    getValue: (item) => item.videoTitle,
  },
  {
    key: "videoType",
    label: "Video Type",
    getValue: (item) => item.videoType,
  },
  {
    key: "durationSeconds",
    label: "Duration (seconds)",
    getValue: (item) => item.durationSeconds,
  },
  {
    key: "views",
    label: "Views",
    getValue: (item) => item.views,
  },
  {
    key: "likes",
    label: "Likes",
    getValue: (item) => item.likes,
  },
  {
    key: "comments",
    label: "Comments",
    getValue: (item) => item.comments,
  },
  {
    key: "engagementRate",
    label: "Engagement Rate",
    getValue: (item) => item.engagementRate,
  },
  {
    key: "publishedAt",
    label: "Published At",
    getValue: (item) => item.publishedAt,
  },
  {
    key: "tags",
    label: "Tags",
    getValue: (item) => (item.tags ?? []).join("; "),
  },
  {
    key: "fullDescription",
    label: "Full Description",
    getValue: (item) => item.fullDescription,
  },
];

export const ALL_YOUTUBE_CSV_COLUMN_KEYS = YOUTUBE_CSV_COLUMNS.map(
  (column) => column.key
);
